import { render } from "./ScriptBody.vue?vue&type=template&id=b0f387f6&scoped=true"
import script from "./ScriptBody.vue?vue&type=script&lang=js"
export * from "./ScriptBody.vue?vue&type=script&lang=js"

import "./../../assets/styles/scripts/main.scss?vue&type=style&index=0&id=b0f387f6&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0f387f6"]])

export default __exports__